export const reviewsData = {
  rating_title: "Reviews",
  rating_highlighted_word: [],
  rating_highlighted_color: "orange",
  rating_subtitle: "4.9 out of 5 Aggregate Rating",
  rating_description:
    "Tomedes is proud to be a recognized leader in the translation industry, and we go that extra mile to stay that way. By reading our translation service reviews, you will see that our main priority is and always will be you.",
  reviews: [
    {
      star_rating: 5,
      company_logo:
        "https://tomedes.gumlet.io/S3UploadedFiles/1669274026Ikea.svg",
      review_text: "Tomedes works exceptionally well",
      review_description:
        "Tomedes works exceptionally well, responds immediately, delivers translations on time (or even earlier!) and is very helpful everytime.",
      reviewer_name: "Maria José Guíñez",
      reviewer_designation: "Communication Analyst IKEA",
    },
    {
      star_rating: 4,
      company_logo:
        "https://tomedes.gumlet.io/S3UploadedFiles/1669274050NBCUniversal.svg",
      review_text: "Best translation service used!",
      review_description:
        "It's a pleasure working with them, always quick in response and very kind. 24/7 service ensures accommodating to your crazy schedules.",
      reviewer_name: "Denisse Best",
      reviewer_designation: "Producer NBC Universal Media LLC",
    },
    {
      star_rating: 4,
      company_logo:
        "https://tomedes.gumlet.io/S3UploadedFiles/1669274068Intuit.svg",
      review_text: "I really enjoyed working with Tomedes",
      review_description:
        "I really enjoyed working with Tomedes. They are very quick and the prices are reasonable. I would definitely work with them again!",
      reviewer_name: "Tiffany Alvoid",
      reviewer_designation: "Sr. Employee Relations Business Partner Intuit",
    },
  ],
  rating_button_text: "See all reviews",
  rating_button_link: "/reviews.php",
};
